const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

export default isIE11;
